import { ErrorLogComponent } from '@cian/error-log-component';
import { Provider as MicrofrontendProvider } from '@cian/mf-react';
import { UiKitRoot, UiKitToastsContextProvider } from '@cian/ui-kit';
import * as React from 'react';
import { Provider } from 'react-redux';

import { IAppStore } from '../../common/state';
import { APP_HYDRATED_ATTRIBUTE } from '../../constants/hydration';
import { IApplicationContext } from '../../types/applicationContext';
import { ApplicationContext } from '../../utils/applicationContext';
import { SaveSearchModalProvider } from '../SaveSearchModalProvider';
import { SearchEngineResultsPageContainer } from '../SearchEngineResultsPageContainer';
import { SubscriptionsContainer } from '../Subscriptions';
import { ActionsCentersLoadable } from './internal/components/ActionsCenters/ActionsCentersLoadable';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: IAppStore;
  /** Заглушка корневого error boundary. В браузере — серверная разметка, снятая до гидрации */
  errorStub?: React.JSX.Element;
}

export const Application: React.FC<IApplicationProps> = ({ reduxStore, context, errorStub }) => {
  const { logger, microfrontendsRegistry } = context;

  React.useEffect(() => {
    document.documentElement.setAttribute(APP_HYDRATED_ATTRIBUTE, 'true');
  }, []);

  return (
    <ErrorLogComponent logger={logger} errorStub={errorStub}>
      <ApplicationContext.Provider value={context}>
        <Provider store={reduxStore}>
          <UiKitRoot deviceType="desktop" useStaticDeviceType>
            <UiKitToastsContextProvider>
              <MicrofrontendProvider registry={microfrontendsRegistry}>
                <ErrorLogComponent logger={logger}>
                  <ActionsCentersLoadable />
                </ErrorLogComponent>
                <SaveSearchModalProvider>
                  <SearchEngineResultsPageContainer />
                  <ErrorLogComponent logger={logger}>
                    <SubscriptionsContainer reduxStore={reduxStore} />
                  </ErrorLogComponent>
                </SaveSearchModalProvider>
              </MicrofrontendProvider>
            </UiKitToastsContextProvider>
          </UiKitRoot>
        </Provider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
